
// CartContext.js
import { addToWishList, getWishList, getWishListItem, removeFromWishList } from "http/wishlist/wishlist"
  import React, { createContext, useEffect, useState } from "react"
  
  const WishlistContext = createContext()
  
  const WishlistProvider = ({ children }) => {
    const [wishlistItems, setWishListItems] = useState([])
    const [wishlistLength, setWishlistLength] = useState(0)
  
    useEffect(() => {
      setWishlistLength(wishlistItems?.length)
    }, [wishlistItems])
  
    const getWishlistItemDetail = async data => {
      try {
        const response = await getWishListItem(data)
        return response.data.data
      } catch (e) {
        console.error(e)
        throw e
      }
    }
  
    const getWishlistData = async () => {
      try {
        const response = await getWishList()
        setWishListItems(response.data.data)
        return response
      } catch (e) {
        console.error(e)
        throw e
      }
    }
  
    const addItemToWishList = async data => {
      try {
        const response = await addToWishList(data)
        return response
      } catch (e) {
        console.error(e)
        throw e
      }
    }
  
    const removeItemFromWishlist = async data => {
      try {
        const response = await removeFromWishList(data)
        return response;
      } catch (e) {
        console.error(e)
        throw e
      }
    }

  
    return (
      <WishlistContext.Provider
        value={{
          wishlistItems,
          getWishlistItemDetail,
          getWishlistData,
          addItemToWishList,
          removeItemFromWishlist,
          wishlistLength,
        }}
      >
        {children}
      </WishlistContext.Provider>
    )
  }
  
  export { WishlistProvider, WishlistContext }
  